// i18next uses BCP-47 tags (zh-Hant-TW, sk-SK); dayjs ships its locales under
// lowercase variants (zh-tw, sk) — translate before applying.
const DAYJS_LOCALE_OVERRIDES: Record<string, string> = {
  'zh-Hant-TW': 'zh-tw',
  'sk-SK': 'sk',
};

export const toDayjsLocale = (lang: string | undefined): string =>
  (lang && DAYJS_LOCALE_OVERRIDES[lang]) ?? lang?.toLowerCase() ?? 'en';
